var exports = {
  "k": "x234b8571--cd155f--container",
  "Q": "x234b8571--cd155f--text",
};

module.exports = exports;
